import { REMOTE_PERMISSIONS, UserPermissions, PermissionStatus } from '@backrs_ui/common-ui';

export const PAYWALL_PERMISSIONS = {
  ACCESS_GROW: REMOTE_PERMISSIONS.ACCESS_GROW,
} as const;

export const UI_PERMISSIONS = {
  ACCESS_SUPER_COACH: REMOTE_PERMISSIONS.ACCESS_SUPER_COACH,
  EMULATE_USERS: REMOTE_PERMISSIONS.EMULATE_USERS,
  HAS_FAMILY_ACCESS: REMOTE_PERMISSIONS.HAS_FAMILY_ACCESS,
  ACCESS_COACH_DASHBOARD: REMOTE_PERMISSIONS.ACCESS_COACH_DASHBOARD,
  ACCESS_COACH_DASHBOARD_LUBAV: REMOTE_PERMISSIONS.ACCESS_COACH_DASHBOARD_LUBAV,
  ACCESS_NETWORKS: REMOTE_PERMISSIONS.ACCESS_NETWORKS,
  ACCESS_DEEP_DIVES: REMOTE_PERMISSIONS.ACCESS_DEEP_DIVES,
  ACCESS_COACHES: REMOTE_PERMISSIONS.ACCESS_COACHES,
  ACCESS_COACH_ASSIGNEES: REMOTE_PERMISSIONS.ACCESS_COACH_ASSIGNEES,
  ACCESS_COHORT_ANALYTICS: REMOTE_PERMISSIONS.ACCESS_COHORT_ANALYTICS,
  MANAGE_INSTITUTION_MEMBERS: REMOTE_PERMISSIONS.MANAGE_INSTITUTION_MEMBERS,
  ACCESS_OPERATOR_FLEET: REMOTE_PERMISSIONS.ACCESS_OPERATOR_FLEET,
  LUBAV_BETA: REMOTE_PERMISSIONS.LUBAV_BETA,
  ...PAYWALL_PERMISSIONS,
} as const;

type UIPermission = (typeof UI_PERMISSIONS)[keyof typeof UI_PERMISSIONS];
type PaywallPermission = (typeof PAYWALL_PERMISSIONS)[keyof typeof PAYWALL_PERMISSIONS];

/** A UI permission that gates rendering by redirect, never the paywall. */
export type RestrictedPermission = Exclude<UIPermission, PaywallPermission>;

export type UIPermissionList = Record<UIPermission, PermissionStatus>;
export type PaywallPermissionList = PaywallPermission[];

export const userPermissionsTransformer = ({ permissions }: UserPermissions): UIPermissionList =>
  Object.fromEntries(
    Object.values(UI_PERMISSIONS).map((key) => [key, permissions?.[key] ?? { allowed: false }]),
  ) as UIPermissionList;
